const careersLinks = {
  internalHiringProgram: {
    name: "INTERNAL HIRING PROGRAM",
    links: [
      {
        name: "Job Connector Bootcamp",
        link: "/career/internal-hiring-program/job-connector-bootcamp",
      },
      {
        name: "Skill Accelerator Bootcamp",
        link: "/career/internal-hiring-program/skill-accelerator-bootcamp",
      },
    ],
  },
};

const servicesLinks = {
  enterprise_technologies: {
    name: "ENTERPRISE TECHNOLOGIES AND SERVICES",
    links: {
      subLink1: [
        { name: "Infor", link: "/consultingservices/infor" },
        { name: "SAP", link: "/consultingservices/sap" },

        // {
        //   name: "Oracle",
        //   link: "/consultingservices/oracle_and_id_edwards",
        // },
        // { name: "Microsoft", link: "/consultingservices/microsoft" },
        { name: "Odoo", link: "/consultingservices/odoo" },
      ],
      subLink2: [
        { name: "Application development", link: "/consultingservices/development" },
        { name: "IV&V QA", link: "/consultingservices/testing" },
        {
          name: "Customer Relationship Management",
          link: "/consultingservices/customer_relationship_management",
        },
        // { name: "AI & ML", link: "/consultingservices/ai_ml" },
        // { name: "Cybersecurity", link: "/consultingservices/cybersecurity" },
        // { name: "Agentic AI", link: "/consultingservices/agentic_ai" },
        // { name: "Generative AI", link: "/consultingservices/generative_ai" },
      ],
      serviceGroups: [
        {
          id: "ai-development",
          name: "AI Development",
          link: "/services/ai-development",
        },
        {
          id: "generative-ai-development",
          name: "Generative AI Development",
          link: "/services/generative-ai-development",
        },
        {
          id: "cloud-migration-managed-services",
          name: "Cloud Migration & Managed Services",
          link: "/services/cloud-migration-managed-services",
        },
        {
          id: "cybersecurity",
          name: "Cybersecurity Services",
          link: "/services/cybersecurity",
        },
        {
          id: "staff-augmentation-managed-services",
          name: "Staff Augmentation & Managed Services",
          link: "/services/staff-augmentation-managed-services",
        },
        {
          id: "enterprise-software-consulting",
          name: "Enterprise Software Consulting (ERP/CRM)",
          link: "/services/enterprise-software-consulting",
        },
        {
          id: "infor",
          name: "Infor",
          link: "/services/infor",
          links: [
            { name: "Infor LN", link: "/services/infor/ln" },
            { name: "Infor CloudSuite Industrial (CSI)", link: "/services/infor/csi" },
            { name: "Infor M3", link: "/services/infor/m3" },
            { name: "Infor MES (Manufacturing Execution System)", link: "/services/infor/mes" },
            { name: "Infor OS", link: "/services/infor/os" },
            { name: "Infor Warehouse Management", link: "/services/infor/wms" },
          ],
        },
      ],
    },
  },

  Products: {
    name: "PRODUCTS",
    links: {
      subLink1: [
        { name: "RantaiPro", link: "/services/RantaiPro" },

        // { name: "IFCA", link: "/services/ifca" },


        { name: "Finsta", link: "/services/finsta" },
      ],

      subLink2: [
        // { name: "Mobillor", link: "/services/mobillor" },
        {
          name: "Office24by7",
          link: "/services/Office24by7",
        },
      ],
    },
  },
};
const industriesLinks = {
  industries_1: {
    links: {
      subLink1: [
        { name: "Automotive", link: "/industries/automotive" },
        // { name: "Construction", link: "/industries/construction" },
        // { name: "Energy", link: "/industries/energy" },
        // { name: "Equipment", link: "/industries/equipment" },
        { name: "Food and Beverage", link: "/industries/food_and_beverage" },
      ],
    },
  },
  industries_2: {
    links: {
      subLink1: [
        // {
        //   name: "Industrial Machinery",
        //   link: "/industries/industrial_macinery_and_equipment",
        // },
        // {
        //   name: "Industrial Manufacturing",
        //   link: "/industries/industrial_manufacturing",
        // },
        {
          name: "Life Sciences",
          link: "/industries/life_sciences",
        },
        {
          name: "Banking, Financial Services & Insurance (BFSI)",
          link: "/services/bsfi",
        },
        // {
        //   name: "High Tech and Electronics",
        //   link: "/industries/high_tech_and_electrinics",
        // },
      ],
    },
  },
};

const insightsLinks = {
  insights_1: {
    links: {
      subLink1: [
        { name: "About us", link: "/insights/aboutus" },
        // { name: "Infor Training", link: "/insights/infor-training" },
        // { name: "Leadership", link: "/insights" },
        // { name: "Customer Stories", link: "/insights/customerstories" },
        { name: "Webinar", link: "/insights/webinar" },
        // { name: " Blog", link: "/insights/blog" },
      ],
    },
  },
};

const inforTalentProgramLinks = {
  name: "INFOR TALENT PROGRAM",
  links: [
    // {
    //   name: "Talent Development Program",
    //   link: "/infor-talent-program/talent-development-program",
    // },
    {
      name: "Certification Bundle",
      link: "/infor-talent-program/certification-bundle",
    },
  ],
};

export {
  servicesLinks,
  industriesLinks,
  insightsLinks,
  careersLinks,
  // partners_allianzes_Links,
  inforTalentProgramLinks,
};
